export default __webpack_public_path__ + "static/media/hot-18.59e5529e.png";